
export default class {
    constructor({store, router}){
        this.store = store
        this.router = router
    }

    install(){
        this.router.addRoutes(this.routes)
        this.store.registerModule(this.name, this.localStore)
        return this
    }
}